import { defineMessages } from 'react-intl'

export const FooterMessages = defineMessages({
  copyright: {
    id: 'footer.copyright',
    description: 'Copyright information in footer',
    defaultMessage: '© Copyright {currentYear} Savant Systems, Inc.',
  },
  loginCopyright: {
    id: 'footer.loginCopyright',
    description: 'Copyright information in footer of "login" pages',
    defaultMessage: `1997-{currentYear} © Savant Technologies LLC. Google Play and the Google Play
    logo are trademarks of Google Inc. Apple and the Apple logo are
    trademarks of Apple Inc., registered in the U.S. and other countries.
    App Store is a service mark of Apple Inc. The Bluetooth work mark is a
    registered trademark owned by Bluetooth SIG, Inc., and any use of such
    mark by GE is under license. Reveal ® is a trademark of Savant
    Technologies LLC. The GE monogram and C by GE are trademarks of
    General Electric Company used under license. GE Lighting, A Savant
    Company products are only intended for use within the continental
    United States, Alaska, Hawaii and Canada.'`,
  },
  privacyPolicy: {
    id: 'footer.privacyPolicy',
    description: 'Link text to "Privacy Policy" ',
    defaultMessage: 'Privacy',
  },
  termsOfService: {
    id: 'footer.termsOfService',
    description: 'Link text to "Terms of Service" ',
    defaultMessage: 'Terms of Service',
  },
  integratorCommunity: {
    id: 'footer.integratorCommunity',
    description: 'Link text to "Integrator Community" ',
    defaultMessage: 'Integrator Community',
  },
  store: {
    id: 'footer.store',
    description: 'Link text to "Store" ',
    defaultMessage: 'Store',
  },
  savantProApp: {
    id: 'footer.savantProApp',
    description: 'Link text to "Savant App" ',
    defaultMessage: 'Savant App',
  },
  savantCom: {
    id: 'footer.savantCom',
    description: 'Link text to "Savant.com" ',
    defaultMessage: 'Savant.com',
  },
  scm: {
    id: 'footer.scm',
    description: 'Product name in footer',
    defaultMessage: 'Savant Central Management, {version}',
  },
})
